<template>

  <div class="flex-grow">
    <div class="bg-theme-light">
      <div class="section container px-6 py-16 mx-auto">
          <div class="items-center lg:flex">
              <div class="w-full flex flex-col jusctify-center text-center">
                  <h1 class="text-5xl text-theme-blue font-semibold">{{title}}</h1>
                  <h4 class="text-gray-900 text-2xl md:text-3xl w-11/12 md:w-9/12 m-auto text-center font-normal py-6">{{subtitle}}</h4>
              </div>
          </div>
      </div>
    </div> 
    <Content />    

  </div> 

</template>


<script>

import Content from  '@/components/bibliotecas/Content'

export default {
  name: "Bibliotecas",
  components: {
    Content
  },
  data(){
      return{
        libraries:"",
        // contents:"",
        title:"",
        subtitle:""
      }
  },  
  watch:{
  },  
  methods: {
    async getContent(view){

      var filter = `?view=${view}`
      var get = `${process.env.VUE_APP_URL_CULTURAPP}api/contents${filter}`
      const response = await fetch(get,{method: 'GET'})
      const contents = await response.json()

      this.title = contents.filter(obj => obj.section == 'header' && obj.element == 'title')[0].content
      this.subtitle = contents.filter(obj => obj.section == 'header' && obj.element == 'subtitle')[0].content
    }
  },  
  mounted () {
    window.scrollTo(0, 0)
  },   
  created(){
     this.getContent('bibliotecas')
  }
};
</script>
